import { render, staticRenderFns } from "./formbuilderViewStep.vue?vue&type=template&id=936b8fda"
import script from "./formbuilderViewStep.vue?vue&type=script&lang=js"
export * from "./formbuilderViewStep.vue?vue&type=script&lang=js"
import style0 from "./formbuilderViewStep.vue?vue&type=style&index=0&id=936b8fda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports